import { useMemo } from 'react';
import { pageSizesOf } from '@/constant/Constant';
import { useGlobalSelector } from './useGlobalState';

/**
 * The page sizes every table offers, from Global Settings › Page Size List.
 * The first one is the default page size.
 */
export function usePageSizes(): number[] {
  const list = useGlobalSelector((s) => s.appSettings.pageSizeList);
  return useMemo(() => pageSizesOf(list), [list]);
}
